import { API_BASE } from '../../config/env';
import type { LandingLocale } from './copy';

export type SalesInquiryType = 'REQUEST_DEMO' | 'REQUEST_TECHNICAL_BRIEFING' | 'JOIN_ROUND';

type SalesInquiryPayload = {
    requestType: SalesInquiryType;
    locale: LandingLocale;
    email: string;
    sourcePage: string;
    name?: string;
    organization?: string;
    fund?: string;
    checkSize?: string;
};

const salesContactMessages: Record<LandingLocale, { success: string; error: string; sending: string }> = {
    en: {
        success: 'Email sent successfully.',
        error: 'Unable to send email right now. Please try again.',
        sending: 'Sending...',
    },
    es: {
        success: 'Correo enviado con éxito.',
        error: 'No se pudo enviar el correo en este momento. Inténtalo de nuevo.',
        sending: 'Enviando...',
    },
    it: {
        success: 'Email inviato con successo.',
        error: 'Impossibile inviare l email in questo momento. Riprova.',
        sending: 'Invio in corso...',
    },
};

export function getSalesContactMessages(locale: LandingLocale) {
    return salesContactMessages[locale];
}

export async function sendSalesInquiry(payload: SalesInquiryPayload) {
    const response = await fetch(`${API_BASE}/landing/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const details = await response.text().catch(() => '');
        throw new Error(details || `Request failed with status ${response.status}`);
    }
}
